import React, { useEffect } from "react";
import styles from "./styles.module.scss";
import SiteWrapper from "../SiteWrapper";
import ContentGutter from "../ContentGutter";
import { AsHtml } from "../../utils/translate";
import { getConfigByLocale } from "../../config/global";
import cx from "classnames";
import {
  pageView,
  useNextButtonDaLabel,
  dispatchEvent
} from "../../utils/analytics";
import { isAtFirstQuestion } from "../../utils/branching";
import replaceImages from "../../utils/replaceImages";
import useAppContext from "../AppContext";
import { useParams } from "react-router-dom";
import StickyFooter from "../StickyFooter";
import { IMG_WIDTH_100_PERC } from "../../config/tags";
import t from "../../utils/translate";
import replaceName from "../../utils/replaceName";
import { FIRST_NAME } from "../Profile/constants";

let quizStartedEventTriggered = false;
export default function Intro({ question, nextQuestion, onNext, profile }) {
  const { questionPath } = useParams();
  const { assessment, newQuiz } = useAppContext();
  const daLabelNextButton = useNextButtonDaLabel(question, null, nextQuestion);

  const atFirstQuestion = isAtFirstQuestion(
    questionPath,
    assessment?.questions
  );

  useEffect(() => {
    pageView(`${question.slug}:intro`);

    if (!quizStartedEventTriggered) {
      quizStartedEventTriggered = true;

      dispatchEvent({
        event: "non_click_event",
        event_key: "quiz:started",
        event_category: "quiz",
        event_action: "quiz_started"
      });
    }
  }, []);

  const imageMargin = "0 auto";
  const imageWidth = !question.tags.includes(IMG_WIDTH_100_PERC)
    ? "auto"
    : undefined;

  const imageDisplay = "block";
  const imageBorderRadius = "32px";
  const headerText1 = replaceName(
    replaceImages(
      question.headerText1,
      question.images,
      imageMargin,
      "auto",
      imageDisplay,
      imageBorderRadius
    ),
    profile[FIRST_NAME]
  );
  const headerText2 = replaceImages(
    question.headerText2,
    question.images,
    imageMargin,
    imageWidth,
    imageDisplay,
    imageBorderRadius
  );

  const footerText1 = replaceImages(
    question.footerText1,
    question.images,
    imageMargin,
    imageWidth,
    imageDisplay,
    imageBorderRadius
  );

  const nextButtonProps = {
    onNext: onNext,
    label: atFirstQuestion
      ? newQuiz.eli
        ? t("ELI_START")
        : t("START")
      : undefined,
    "da-category": "prepaywall_assessment",
    "da-action": "next",
    "da-label": daLabelNextButton
  };

  const legalUnderCta = getConfigByLocale(window.ww.locale)["legalUnderCta"];

  return (
    <>
      <div
        className={cx(styles.section, {
          [styles.nonStickyMainWrapperIphone]: newQuiz.isIphone,
          [styles.nonStickyMainWrapperAndroid]: newQuiz.isAndroid
        })}
      >
        <div className={styles.content}>
          <ContentGutter>
            <SiteWrapper size="small" contentWrapper bottomPaddingLarge>
              <h1 className={styles.header} data-test="intro-header">
                <AsHtml
                  value={headerText1}
                  interpolations={{ name: profile.firstName }}
                />
              </h1>
              {question.headerText2 && (
                <div className={styles.description}>
                  <AsHtml
                    value={headerText2}
                    interpolations={{ name: profile.firstName }}
                  />
                </div>
              )}
              {footerText1 && !legalUnderCta && (
                <div className={styles.footer}>
                  <AsHtml value={footerText1} />
                </div>
              )}
            </SiteWrapper>
          </ContentGutter>
        </div>
        <StickyFooter
          message={{ label: legalUnderCta ? footerText1 : null }}
          nextButtonProps={nextButtonProps}
        />
      </div>
    </>
  );
}
